var map = {
	"./БарышниковаММ.png": 7218,
	"./БобышевПП.jpg": 3605,
	"./ЖабинВЕ.jpg": 6709,
	"./МаслаковаВВ.jpg": 3154,
	"./ОверчукАЛ.png": 5610,
	"./ПрисяжныйМС.png": 250,
	"./СергеевАВ.png": 4680,
	"./СусловаТА.png": 7635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1646;